export default {
	computed : {
		// Put Disciplines to v-model and set name to show
		discipline_array: function(){
			var keys = []
			let val = this.provider_data.organization_discipline_ids
			for(let i in val){
				if(val[i].name != null){
					// if(!keys.some(key=>key.id === val[i].id)){
						keys.push({name: val[i].name, id:val[i].id})
					// }
				}
			}
			return keys
		},
	},
	methods: {
		getLocations: function () {
			var params = {
				id: '_',
				filters: {
					type: 'location'
				}
			}
			if (this.user_role != 'organization') {
				params.id = this.organization.id
			}
			this.$store.dispatch('getTaxonomyValues', params).then((res) => {
				this.locations = res.data.data;
				this.locations_loaded = true
			}).catch((error) => {
				console.log(error);
			});
		},
		locationChanged: function(val){
			if (val) {
				console.log("MIXIN: ", val)
				this.provider_data.organization_location_id = val
			}
		},
		getDisciplines : function(){
			var params = {
				id : '_',
				filters : {
					type : 'discipline',
				}
			}

			this.$store.dispatch('getTaxonomyValues', params).then((res) => {
				this.disciplines = res.data.data;
			}).catch((error) => {
				console.log(error);
			});
		},
	}
};



// WEBPACK FOOTER //
// ./src/components/shared/organizationProviderMixin.js